import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ColorIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Color palette / droplet icon */}
      <path
        d="M12 2C12 2 5 10 5 14a7 7 0 1 0 14 0c0-4-7-12-7-12z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
      {/* Inner highlight */}
      <circle cx="10" cy="15" r="2" fill={color} opacity="0.4" />
    </BaseIcon>
  ),
);

ColorIcon.displayName = 'ColorIcon';
